/** jsxImportSource theme-ui */
import styled from '@emotion/styled'
import { useBreakpointIndex } from '@theme-ui/match-media'
import cookieThumb from 'assets/gifs/cookie-thumb.gif'
import sliderTracker from 'assets/images/slider-tracker.png'
import { CenteredRow } from 'components/Flex'
import QuantityBadge from 'components/QuantityBadge'
import React from 'react'
import ReactSlider from 'react-slider'

interface Props {
  quantity: number
  setQuantity: React.Dispatch<React.SetStateAction<number>>
  isLoading: boolean
}

const StyledSlider = styled(ReactSlider)`
  width: 634px;
  height: 37px;
  background: url(${sliderTracker});
  display: flex;
  align-items: center;
`

const CookieThumbGif = styled.div`
  width: 117.5px;
  height: 75px;
  background: url(${cookieThumb});
  &:focus {
    outline: none;
  }
  background-size: contain;
`

const SmallCookieThumbGif = styled(CookieThumbGif)`
  width: calc(117px * 0.5);
  height: calc(75px * 0.5);
`

const SmallQuantityBadge = styled(QuantityBadge)``

const SmallStyledSlider = styled(StyledSlider)`
  width: calc(634px * 0.3);
  height: calc(37px * 0.3);
`

const Slider = ({ quantity, setQuantity, isLoading }: Props) => {
  const index = useBreakpointIndex()
  return index > 2 ? (
    <CenteredRow>
      <StyledSlider
        disabled={isLoading}
        onChange={(value) => setQuantity(parseInt(value.toString()))}
        max={20}
        min={1}
        renderThumb={(props: any) => <CookieThumbGif {...props} />}
        value={quantity}
        withTracks={false}
      />
      <QuantityBadge quantity={quantity} />
    </CenteredRow>
  ) : (
    <CenteredRow>
      <SmallStyledSlider
        disabled={isLoading}
        onChange={(value) => setQuantity(parseInt(value.toString()))}
        max={20}
        min={1}
        renderThumb={(props: any) => <SmallCookieThumbGif {...props} />}
        value={quantity}
        withTracks={false}
      />
      <SmallQuantityBadge quantity={quantity} />
    </CenteredRow>
  )
}

export default Slider
